import { render, staticRenderFns } from "./mail-template.dialogue.vue?vue&type=template&id=1e99e8bd&scoped=true"
import script from "./mail-template.dialogue.vue?vue&type=script&lang=js"
export * from "./mail-template.dialogue.vue?vue&type=script&lang=js"
import style0 from "./mail-template.dialogue.vue?vue&type=style&index=0&id=1e99e8bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99e8bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e99e8bd')) {
      api.createRecord('1e99e8bd', component.options)
    } else {
      api.reload('1e99e8bd', component.options)
    }
    module.hot.accept("./mail-template.dialogue.vue?vue&type=template&id=1e99e8bd&scoped=true", function () {
      api.rerender('1e99e8bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/mail-templates/components/mail-template.dialogue.vue"
export default component.exports